angular.module('app.filters').filter('macAddress', () =>
    function(input, separator) {
        if (separator == null) { separator = ':'; }
        if (!!input) {
          return input.match(/.{1,2}/g).join(separator);
        }
        return '';
    }
);


// WEBPACK FOOTER //
// ./filters/mac-address.js